<template>
    <div class="column is-full">
        <h2 class="has-text-centered has-text-weight-semibold is-size-4">Info de Mercadoapgo.</h2>
        <div class="card-content">
            <p><b>Medio de pago elegido:</b> {{order.payment.mpPaymentInformation.getMpPaymentTypeIdDisplay}} {{order.payment.mpPaymentInformation.mpPaymentMethodId}}</p>
            <p><b>Estado:</b> {{order.payment.mpPaymentInformation.getStatusDisplay}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        order:{
            type: Object,
            default: new Object({})
        }
    }
}
</script>